<div class="detail-shell" *ngIf="!loading(); else loadingState">
  <header class="detail-header">
    <div>
      <h1>{{ audienceTitle() }}</h1>
    </div>
    <div class="detail-header__actions">
      <button
        type="button"
        class="button button--accent"
        (click)="generateAllTargetAreas()"
        [disabled]="locationLoading()"
      >
        All Generate Target Area
      </button>
      <button
        type="button"
        class="button button--accent"
        (click)="handleTargetAreaAction()"
        [disabled]="locationLoading()"
      >
        {{ targetAreaActionLabel() }}
      </button>
      <button type="button" class="button button--secondary" (click)="goBack()">
        Back to Audience List
      </button>
    </div>
  </header>

  <section class="detail-status">
    <span class="status status--error" *ngIf="errorMessage()">
      {{ errorMessage() }}
    </span>
    <span class="status status--info" *ngIf="locationLoading()">
      <span class="spinner__dot"></span>
      <span>Loading target areas...</span>
    </span>
    <span class="status status--success" *ngIf="!locationLoading() && locationStatus()">
      {{ locationStatus() }}
    </span>
    <span class="status status--error" *ngIf="locationError()">
      {{ locationError() }}
    </span>
  </section>

  <nav class="breadcrumb">
    <a routerLink="/">Home</a>
    <span class="breadcrumb__separator">›</span>
    <a [routerLink]="['/audiences', serviceId()]" *ngIf="serviceId() as sid; else audienceFallback">
      Target Audience Profiles
    </a>
    <ng-template #audienceFallback>
      <span>Target Audience Profiles</span>
    </ng-template>
    <span class="breadcrumb__separator">›</span>
    <span>{{ audienceTitle() }}</span>
  </nav>

  <ng-container *ngIf="audience() as data">
    <section class="detail-card">
      <header class="detail-card__header">
        <h2>Audience Overview</h2>
      </header>
      <dl class="detail-grid">
        <div class="detail-grid__item">
          <dt>Audience Type</dt>
          <dd>{{ data.audience_type || 'N/A' }}</dd>
        </div>
        <div class="detail-grid__item">
          <dt>Market Type</dt>
          <dd>{{ renderText(data.market_type) }}</dd>
        </div>
        <div class="detail-grid__item">
          <dt>Company Size</dt>
          <dd>{{ renderText(data.company_size) }}</dd>
        </div>
        <div class="detail-grid__item">
          <dt>Industries</dt>
          <dd>
            <ng-container *ngIf="renderArray(data.industries) as industries">
              <span *ngIf="!industries.length">N/A</span>
              <ul class="detail-chip-list" *ngIf="industries.length">
                <li *ngFor="let item of industries">{{ item }}</li>
              </ul>
            </ng-container>
          </dd>
        </div>
        <div class="detail-grid__item">
          <dt>Decision Makers</dt>
          <dd>
            <ng-container *ngIf="renderArray(data.decision_makers) as decisions">
              <span *ngIf="!decisions.length">N/A</span>
              <ul class="detail-chip-list" *ngIf="decisions.length">
                <li *ngFor="let item of decisions">{{ item }}</li>
              </ul>
            </ng-container>
          </dd>
        </div>
        <div class="detail-grid__item">
          <dt>Locations</dt>
          <dd>{{ renderText(data.locations) }}</dd>
        </div>
        <div class="detail-grid__item">
          <dt>Market Size Estimate</dt>
          <dd>{{ renderText(data.market_size_estimate) }}</dd>
        </div>
        <div class="detail-grid__item">
          <dt>Priority Level</dt>
          <dd>{{ renderText(data.priority_level) }}</dd>
        </div>
        <div class="detail-grid__item detail-grid__item--full">
          <dt>Needs</dt>
          <dd>
            <ng-container *ngIf="renderObjectSummary(data.needs) as needs">
              <span *ngIf="!needs.length">N/A</span>
              <ul class="detail-list" *ngIf="needs.length">
                <li *ngFor="let item of needs">{{ item }}</li>
              </ul>
            </ng-container>
          </dd>
        </div>
        <div class="detail-grid__item detail-grid__item--full">
          <dt>Behavior</dt>
          <dd>
            <ng-container *ngIf="renderObjectSummary(data.behavior) as behavior">
              <span *ngIf="!behavior.length">N/A</span>
              <ul class="detail-list" *ngIf="behavior.length">
                <li *ngFor="let item of behavior">{{ item }}</li>
              </ul>
            </ng-container>
          </dd>
        </div>
        <div class="detail-grid__item detail-grid__item--full">
          <dt>Psychographics</dt>
          <dd>
            <ng-container *ngIf="renderObjectSummary(data.psychographics) as psychographics">
              <span *ngIf="!psychographics.length">N/A</span>
              <ul class="detail-list" *ngIf="psychographics.length">
                <li *ngFor="let item of psychographics">{{ item }}</li>
              </ul>
            </ng-container>
          </dd>
        </div>
        <div class="detail-grid__item detail-grid__item--full">
          <dt>Market Insights</dt>
          <dd>
            <ng-container *ngIf="renderObjectSummary(data.market_insights) as insights">
              <span *ngIf="!insights.length">N/A</span>
              <ul class="detail-list" *ngIf="insights.length">
                <li *ngFor="let item of insights">{{ item }}</li>
              </ul>
            </ng-container>
          </dd>
        </div>
        <div class="detail-grid__item detail-grid__item--full">
          <dt>Recommendations</dt>
          <dd>
            <ng-container *ngIf="renderArray(data.recommendations) as recommendations">
              <span *ngIf="!recommendations.length">N/A</span>
              <ul class="detail-list" *ngIf="recommendations.length">
                <li *ngFor="let item of recommendations">{{ item }}</li>
              </ul>
            </ng-container>
          </dd>
        </div>
      </dl>
    </section>
  </ng-container>

</div>

<ng-template #loadingState>
  <div class="loading-state">
    <span class="spinner">
      <span class="spinner__dot"></span>
      <span>Loading audience insights...</span>
    </span>
  </div>
</ng-template>


